<script setup>
import { reactiveOmit } from '@vueuse/core';
import { ListboxContent, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwarded = useForwardProps(delegatedProps);
</script>

<template>
    <ListboxContent :class="cn('max-h-[200px] overflow-x-hidden overflow-y-auto', props.class)" v-bind="forwarded">
        <div role="presentation">
            <slot />
        </div>
    </ListboxContent>
</template>
